<template>
    <v-container fluid>
        <v-row class="px-2">
            <v-col cols="12">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="px-2">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="orders"
                    dense
                    :search="search"
                    :loading="loading"
                    class="elevation-1"
                    :options="{
                        page: 1,
                        itemsPerPage: 10
                    }"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click="viewOrder(item)"
                            >mdi-eye-outline
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog
            v-model="$store.state.invoice.dialogOrder"
            transition="dialog-bottom-transition"
            overlay-color="accent"
            width="1200px"
        >
            <OrderData
                :isModal="true"
                v-if="$store.state.invoice.dialogOrder"
            />
        </v-dialog>
    </v-container>
</template>
<script>
import OrderData from './OrderData.vue';
import axios from 'axios';
export default {
    components: {
        OrderData
    },
    props: ['parms'],
    data: function() {
        return {
            orders: [],
            loading: true,
            search: '',
            orderView: false,
            headers: [
                {
                    text: 'Date',
                    align: 'start',
                    sortable: false,
                    value: 'Date'
                },
                {
                    text: 'Order',
                    align: 'start',
                    sortable: false,
                    value: 'OrderID'
                },
                {
                    text: 'BOL',
                    align: 'start',
                    sortable: false,
                    value: 'BillOfLading'
                },
                {
                    text: 'Station',
                    align: 'start',
                    sortable: false,
                    value: 'Name'
                },
                {
                    text: 'Terminal',
                    align: 'start',
                    sortable: false,
                    value: 'TerminalName'
                },
                {
                    text: 'Order Status',
                    align: 'start',
                    sortable: false,
                    value: 'OrderStatus'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '8%'
                }
            ]
        };
    },

    mounted() {
        console.log(this.parms);
        this.loadOrders();
    },
    methods: {
        viewOrder: function(item) {
            console.log(item.OrderID);
            this.$store.state.orderInfo.orderId = item.OrderID;
            this.$store.state.invoice.dialogOrder = true;
        },
        loadOrders: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('invoice/orders', this.parms)
                .then(response => {
                    console.log(response.data);
                    this.orders = Object.keys(response.data).map(
                        i => response.data[i]
                    );
                    this.loading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        }
    }
};
</script>
